<div class="rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
  <h1 class="text-xl font-semibold text-gray-800 dark:text-white">Venue view coming soon</h1>
  <p class="text-sm text-gray-500 dark:text-gray-400">This page is under construction.</p>
</div>
